import { useEffect } from 'react';
import { useNavigate, Link, useSearchParams } from 'react-router-dom';
import { ChartBar, Users, Lightning } from '@phosphor-icons/react';

import { useAuthStore } from '@/stores';
import { GoogleLoginButton } from '@/components/features/GoogleLoginButton/GoogleLoginButton';
import { Footer } from '@/components/layout/Footer/Footer';
import { ROUTES } from '@/constants';

import styles from './Login.module.css';

export function Login() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const { isLogged } = useAuthStore();
    const returnTo = searchParams.get('returnTo');

    useEffect(() => {
        document.title = 'Iniciar Sesion — Ratio';
    }, []);

    useEffect(() => {
        if (isLogged) {
            navigate(returnTo || ROUTES.feed, { replace: true });
        }
    }, [isLogged, navigate, returnTo]);

    return (
        <div className={styles.page}>
            <div className={styles.heroPanel}>
                <div className={styles.heroBg} />
                <div className={styles.heroContent}>
                    <img src="/logo.svg" alt="Ratio" className={styles.heroLogo} />
                    <h1 className={styles.heroTitle}>Ratio</h1>
                    <p className={styles.heroTagline}>
                        La forma mas divertida de crear encuestas, trivias y decidir juntos.
                    </p>
                    <div className={styles.features}>
                        <div className={styles.feature}>
                            <div className={styles.featureIcon}>
                                <ChartBar size={20} weight="bold" />
                            </div>
                            <span>Crea encuestas en segundos</span>
                        </div>
                        <div className={styles.feature}>
                            <div className={styles.featureIcon}>
                                <Lightning size={20} weight="bold" />
                            </div>
                            <span>Trivias con respuestas correctas</span>
                        </div>
                        <div className={styles.feature}>
                            <div className={styles.featureIcon}>
                                <Users size={20} weight="bold" />
                            </div>
                            <span>Comparte y vota con amigos</span>
                        </div>
                    </div>
                </div>
                <div className={styles.heroGlow} />
            </div>

            <div className={styles.formPanel}>
                <div className={styles.formContent}>
                    <div className={styles.brand}>
                        <img src="/logo.svg" alt="Ratio" className={styles.logoImg} />
                        <h2 className={styles.title}>Bienvenido</h2>
                        <p className={styles.subtitle}>
                            {returnTo
                                ? 'Inicia sesion para registrar tu voto'
                                : 'Inicia sesion para continuar'
                            }
                        </p>
                    </div>

                    <div className={styles.loginSection}>
                        <GoogleLoginButton />
                        <p className={styles.legalText}>
                            Al continuar, aceptas los{' '}
                            <Link to={ROUTES.terms}>Terminos</Link> y{' '}
                            <Link to={ROUTES.privacy}>Privacidad</Link>
                        </p>
                    </div>
                </div>

                <div className={styles.footerWrapper}>
                    <Footer />
                </div>
            </div>
        </div>
    );
}
